let cache = {};
let sessionCache = {};
let isError = false;
let isSessionError = false;
window.__myCache = cache;
window.__mySessionCache = sessionCache;
var store = require('store');
let Store = {
  // ============ localStorage 相关方法 ============
  get(key) {
    let r =
      isError && cache[key] !== undefined
        ? cache[key]
        : cache[key] || store.get(key);
    return r;
  },
  set(key, v, catchCb, useCb) {
    let val;
    if (v !== null && typeof v === 'object') {
      // 同一个引用类型会引发问题，如外部修改了引用的对象，会导致store中的对象也被修改
      val = JSON.parse(JSON.stringify(v));
    } else {
      val = v;
    }
    cache[key] = val;
    try {
      store.set(key, val);
    } catch (error) {
      isError = true;
      try {
        // console.error('set Store error', error);
        useCb && catchCb && catchCb();
        // slog.error('--set Store error--', key, error);
      } catch (error) {}
    }
  },
  remove(key) {
    // store.remove(key);
    cache[key] = undefined;
    delete cache[key];
    store.remove(key);
  },
  clear() {
    // store.clearAll();
    // console.log('---clear---');
    cache = {};
    store.clearAll();
  },

  // ============ sessionStorage 相关方法 ============
  getSession(key) {
    if (isSessionError && sessionCache[key] !== undefined) {
      return sessionCache[key];
    }
    if (sessionCache[key] !== undefined) {
      return sessionCache[key];
    }
    try {
      const val = window.sessionStorage.getItem(key);
      if (val === null) {
        return undefined;
      }
      const parsed = JSON.parse(val);
      sessionCache[key] = parsed;
      return parsed;
    } catch (error) {
      return undefined;
    }
  },
  setSession(key, v, catchCb, useCb) {
    let val;
    if (v !== null && typeof v === 'object') {
      // 同一个引用类型会引发问题，如外部修改了引用的对象，会导致store中的对象也被修改
      val = JSON.parse(JSON.stringify(v));
    } else {
      val = v;
    }
    sessionCache[key] = val;
    try {
      window.sessionStorage.setItem(key, JSON.stringify(val));
    } catch (error) {
      isSessionError = true;
      try {
        // console.error('set sessionStorage error', error);
        useCb && catchCb && catchCb();
        // slog.error('--set sessionStorage error--', key, error);
      } catch (error) {}
    }
  },
  removeSession(key) {
    sessionCache[key] = undefined;
    delete sessionCache[key];
    try {
      window.sessionStorage.removeItem(key);
    } catch (error) {}
  },
  clearSession() {
    sessionCache = {};
    try {
      window.sessionStorage.clear();
    } catch (error) {}
  }
};
// window.__Store__ = cache;
export default Store;
